<template>
  <div>
    <footer class="main-footer row mx-0 bg-black pt-5 px-3 p-lg-4">
      <div class="col-12 col-lg-12 mx-auto container">
        <div class="row">
          <div class="col-lg-3 col-md-4 mx-auto">
            <nav class="navbar navbar-dark pl-0">
              <ul class="navbar-nav w-100 py-3">
                <li>
                  <h4 class="text-white font-weight-normal">
                    GOVERNANÇA <br />
                    CORPORATIVA
                  </h4>
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/governanca-corporativa/diretoria-e-conselho/" target="_blank" class="nav-link"
                    >Diretoria e Conselho</a
                  >
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/governanca-corporativa/composicao-acionaria/" target="_blank" class="nav-link"
                    >Composição Acionária</a
                  >
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/governanca-corporativa/estatuto-codigos-e-politicas/" target="_blank" class="nav-link"
                    >Estatuto, Códigos e Políticas</a
                  >
                </li>
              </ul>
            </nav>
          </div>

          <div class="col-lg-3 col-md-4 mx-auto">
            <nav class="navbar navbar-dark pl-0">
              <ul class="navbar-nav w-100 py-3">
                <li>
                  <h4 class="text-white font-weight-normal">
                    informações <br />
                    financeiras
                  </h4>
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/informacoes-financeiras/central-de-resultados/" target="_blank" class="nav-link" to="/#">
                    Central de Resultados</a
                  >
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/informacoes-financeiras/publicacoes-cvm/" target="_blank" class="nav-link" to="/#">
                    Publicações CVM
                  </a>
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/informacoes-financeiras/cotacoes-e-graficos/" target="_blank" class="nav-link" to="/#">
                    Cotações e Gráficos</a
                  >
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/informacoes-financeiras/cobertura-de-analistas/" target="_blank" class="nav-link" to="/#">
                    Cobertura de Analistas
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <div class="col-lg-3 col-md-4 mx-auto">
            <nav class="navbar navbar-dark pl-0">
              <ul class="navbar-nav w-100 py-3">
                <li>
                  <h4 class="text-white font-weight-normal">serviços ri</h4>
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/servicos-ri/calendario-de-eventos/" target="_blank" class="nav-link">
                    Calendário de Eventos</a
                  >
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/servicos-ri/fale-com-ri/" target="_blank" class="nav-link"
                    >Fale com RI</a
                  >
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/servicos-ri/cadastre-se-no-mailing/" target="_blank" class="nav-link">
                    Cadastre-se no Mailing</a
                  >
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/servicos-ri/perguntas-frequentes/" target="_blank" class="nav-link">
                    Perguntas Frequentes</a
                  >
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/servicos-ri/glossario/" target="_blank" class="nav-link">
                    Glossário
                  </a>
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/servicos-ri/fatores-de-risco/" target="_blank" class="nav-link">
                    Fatores de Risco
                  </a>
                </li>
                <li class="nav-item">
                  <a href="https://www.restoque.com.br/servicos-ri/notas-legais/" target="_blank" class="nav-link">
                    Notas Legais</a
                  >
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-lg-3 col-md-12" v-if="$route.params.group == 'le-lis-blang'">
            <nav class="navbar navbar-dark px-0">
              <ul class="row pl-3 pl-lg-0 py-3">
                <li class="col-12">
                  <h4 class="text-white social font-weight-normal">
                    Acompanhe
                  </h4>
                </li>
                <li class="col-lg-4 col-3 col-xl-3 p-0">
                  <a href="https://www.instagram.com/lelisblanc/" target="_blank">
                    <img
                      src="@/assets/images/logo-instagram-png-fundo-transparente13.png"
                      alt="Instagram"
                    />
                  </a>
                </li>
                <li class="col-12">
                  <a href="https://www.lelis.com.br" target="_blank">www.lelis.com.br </a>
                </li>
              </ul>
            </nav>
          </div>
           <div class="col-lg-3 col-md-12" v-if="$route.params.group == 'dudalina'">
            <nav class="navbar navbar-dark px-0">
              <ul class="row pl-3 pl-lg-0 py-3">
                <li class="col-12">
                  <h4 class="text-white social font-weight-normal">
                    Acompanhe
                  </h4>
                </li>
                <li class="col-lg-4 col-3 col-xl-3 p-0">
                  <a href="https://www.instagram.com/DUDALINA/" target="_blank">
                    <img
                      src="@/assets/images/logo-instagram-png-fundo-transparente13.png"
                      alt="Instagram"
                    />
                  </a>
                </li>
                <li class="col-12">
                  <a href="https://www.dudalina.com.br" target="_blank">www.dudalina.com.br </a>
                </li>
              </ul>
            </nav>
          </div>
           <div class="col-lg-3 col-md-12" v-if="$route.params.group == 'john-john'">
            <nav class="navbar navbar-dark px-0">
              <ul class="row pl-3 pl-lg-0 py-3">
                <li class="col-12">
                  <h4 class="text-white social font-weight-normal">
                    Acompanhe
                  </h4>
                </li>
                <li class="col-lg-4 col-3 col-xl-3 p-0">
                  <a href="https://www.instagram.com/JOHNJOHNDENIM/" target="_blank">
                    <img
                      src="@/assets/images/logo-instagram-png-fundo-transparente13.png"
                      alt="Instagram"
                    />
                  </a>
                </li>
                <li class="col-12">
                  <a href="https://www.johnjohndenim.com.br" target="_blank">www.johnjohndenim.com.br</a>
                </li>
              </ul>
            </nav>
          </div>
           <div class="col-lg-3 col-md-12" v-if="$route.params.group == 'bobo'">
            <nav class="navbar navbar-dark px-0">
              <ul class="row pl-3 pl-lg-0 py-3">
                <li class="col-12">
                  <h4 class="text-white social font-weight-normal">
                    Acompanhe
                  </h4>
                </li>
                <li class="col-lg-4 col-3 col-xl-3 p-0">
                  <a href="https://www.instagram.com/bobonews/" target="_blank">
                    <img
                      src="@/assets/images/logo-instagram-png-fundo-transparente13.png"
                      alt="Instagram"
                    />
                  </a>
                </li>
                <li class="col-12">
                  <a href="https://www.bobo.com.br" target="_blank">www.bobo.com.br</a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-lg-3 col-md-12" v-if="$route.params.group == 'rosa-cha'">
            <nav class="navbar navbar-dark px-0">
              <ul class="row pl-3 pl-lg-0 py-3">
                <li class="col-12">
                  <h4 class="text-white social font-weight-normal">
                    Acompanhe
                  </h4>
                </li>
                <li class="col-lg-4 col-3 col-xl-3 p-0">
                  <a href="https://www.instagram.com/rosacha/" target="_blank">
                    <img
                      src="@/assets/images/logo-instagram-png-fundo-transparente13.png"
                      alt="Instagram"
                    />
                  </a>
                </li>
                <li class="col-12">
                  <a href="https://www.rosacha.com.br" target="_blank">www.rosacha.com.br</a>
                </li>
              </ul>
            </nav>
          </div>
           <div class="col-lg-3 col-md-12" v-if="$route.params.group == 'individual'">
            <nav class="navbar navbar-dark px-0">
              <ul class="row pl-3 pl-lg-0 py-3">
                <li class="col-12">
                  <h4 class="text-white social font-weight-normal">
                    Acompanhe
                  </h4>
                </li>
                <li class="col-lg-4 col-3 col-xl-3 p-0">
                  <a href="https://www.instagram.com/vistaindividual/" target="_blank">
                    <img
                      src="@/assets/images/logo-instagram-png-fundo-transparente13.png"
                      alt="Instagram"
                    />
                  </a>
                </li>
                <li class="col-12">
                  <a href="https://www.individual.com.br" target="_blank">www.individual.com.br</a>
                </li>
              </ul>
            </nav>
          </div>
           <div class="col-lg-3 col-md-12" v-if="!$route.params.group || $route.params.group == 'industria' || $route.params.group ==  'corporativas'">
            <nav class="navbar navbar-dark px-0">
              <ul class="row pl-3 pl-lg-0 py-3">
                <li class="col-12">
                  <h4 class="text-white social font-weight-normal">
                    Acompanhe
                  </h4>
                </li>
                  <li class="col-lg-4 col-3 col-xl-3 p-0">
                  <a href="https://www.linkedin.com/company/restoque-sa/" target="_blank">
                    <img
                      src="@/assets/images/linkedin.png"
                      alt="Instagram"
                    />
                  </a>
                <li class="col-12">
                  <a href="https://www.restoque.com.br/" target="_blank">www.restoque.com.br</a>
                </li>
                    <li class="col-12">
                  <a href="https://www.restoque.com.br/etica-e-sustentabilidade/" target="_blank">Ações de ética e sustentabilidade</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import FacebookIcon from "vue-material-design-icons/Facebook.vue";
import InstagramIcon from "vue-material-design-icons/Instagram.vue";
import LinkedinIcon from "vue-material-design-icons/Linkedin.vue";
import TwitterIcon from "vue-material-design-icons/Twitter.vue";
import PlayIcon from "vue-material-design-icons/Play.vue";

export default {
  name: "MainFooter",

  computed: {
    galeriaTimes() {
      return this.$store.state.teams;
    },
  },

  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    PlayIcon,
  },
};
</script>


<style lang="scss" scoped>
.main-footer {
  margin-top: 4rem;
}
p {
  color: #fff;
  font-size: 1.2rem;
  &:first-of-type {
    margin-top: 1.3rem;
  }
}
li {
  margin: 0.3rem 0px;
  padding: 0px;
  h4 {
    font-size: 1.7rem;
    line-height: calc(1.5rem * 1.4);
    margin-bottom: 1rem;
    text-transform: uppercase;
    &.social {
      height: 40px;
    }
    &:not(.social) {
      height: 60px;
    }
  }
}
.nav-link {
  color: #fff !important;
  padding: 0px !important;
  font-size: 1.4rem;
  font-weight: 400;
  font-family: 'Proxima Nova Lt';
  &:hover {
    color: theme-color(primary) !important;
  }
}
img {
  width: 40px;
}
</style>